const ButtonSpinner = ({
  isDisabled = false,
  isLoading = false,
  text,
  className,
  onClick,
  type,
}: {
  isDisabled?: boolean;
  isLoading?: boolean;
  text: string;
  className: string;
  onClick?: () => void;
  type?: 'submit';
}) => (
  <button className={className} type={type === 'submit' ? 'submit' : 'button'} disabled={isDisabled} onClick={onClick}>
    {isLoading && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />}
    {text}
  </button>
);

// eslint-disable-next-line import/no-default-export
export default ButtonSpinner;
